import { formatDate } from "@/utils";

export const DateRenderer = (col) => (rowData) => {
    const value = rowData?.[col.field];
    const { dateFormat } = col?.config || {};
    const format = dateFormat;
    return value ? formatDate(value, format) : "-";
};